<template>
  <div class="responsible-manager">
    <div class="responsible-manager__header">
      <h3 class="responsible-manager__header-title">Ответственный HR-менеджер</h3>

      <p class="responsible-manager__header-subtitle">Выберите HR-менеджера, который будет сопровождать данного кандидата</p>
    </div>

    <VSearchSelect
        class="responsible-manager__select"
        placeholder="Выберите HR-менеджера для кандидата*"
        :items="hrOptions"
        :error="props.error"
        @selectItem="onSelectResponsibleHr"
        @input="debouncedSearchResponsible"
        v-model="searchResponsibleHr"
    />
    <p class="responsible-manager__form-field-error"
       v-if="props.error">
      Заполните обязательное поле
    </p>
  </div>
</template>
<script setup>
import {computed, onMounted, ref, watch} from "vue";
import common from "@/api/common";
import {debounce} from "@/services/helpers";
const emit = defineEmits(["update:modelValue"]);

const props = defineProps({
  modelValue: [String, Number],
  error: Boolean
})

const searchResponsibleHr = ref('')
const responsibleHrOptions = ref([])
const hrOptions = computed(() => {
  return responsibleHrOptions.value.map(({fio, ...rest}) => ({...rest, name: fio})).filter((item) =>
      item.name.toLowerCase().includes(searchResponsibleHr.value.toLowerCase())
  );
})

const onSelectResponsibleHr = (item) => {
  emit('update:modelValue', item?.id)
  searchResponsibleHr.value = item?.name;
};


const debouncedSearchResponsible = debounce(() => searchResponsible(), 400);
const searchResponsible = async () => {
  if (!searchResponsibleHr.value) {
    emit('update:modelValue', null)
    searchResponsibleHr.value = '';
  }
};

onMounted(async () => {
  const options = await common.getResponsibleHrOptions();
  if(options?.list) {
    responsibleHrOptions.value = options?.list
  }
  hrOptions.value.forEach((item) => {
    if (item?.id === props.modelValue) {
      searchResponsibleHr.value = item?.name;
    }
  })
})
</script>
<style lang="scss" scoped>
.responsible-manager {
  padding: 24px;
  border-radius: 16px;
  background-color: #fff;
  margin-top: 32px;
  box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.04);

  &__header-title {
    color: $dark;
    font-size: 20px;
    font-weight: 500;
  }

  &__header-subtitle {
    margin-top: 16px;
    color: #8F9CAC;
    font-size: 14px;
  }

  &__form-field-error {
    margin-top: 16px;
    font-size: 14px;
    color: $red;
  }

  &__select {
    width: 100%;
    height: 40px;
    margin-top: 20px;

    :deep(.v-select__header) {
      height: 40px;
    }


    :deep(.v-select__header-value) {
      top: 12px;
      padding-right: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow-x: hidden;
      font-weight: 500;
    }
    :deep(.v-select__header_selected) {
      .v-select__header-palceholder {
        top: 2px;
        display: none;
      }
    }
    :deep(.v-select__header-palceholder) {
      color: $gray;
    }
    :deep(.v-input__placeholder) {
      color: $gray;
    }
  }
}
</style>